import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.FIND_AND_REPLACE, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) =>
  Helpers.coalesceMessages(
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.selectedColumns,
      'Cannot find and replace by the same column more than once.'
    ),
    config.findAndReplaceOptions.findAndReplaceType !== 'LITERAL' ||
      config.findAndReplaceOptions.literalString?.length > 0
      ? null
      : 'Find text must be at least one character',
    config.findAndReplaceOptions.findAndReplaceType !== 'REGEX' ||
      config.findAndReplaceOptions.patternString?.length > 0
      ? null
      : 'Regex pattern must be at least one character'
  );

export default {
  stepType: PipelineStepType.FIND_AND_REPLACE,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.FIND_AND_REPLACE, 0>;
